import { ProfileComponent } from './profile.component'
import { AuthGuard } from '@guards/auth.guard'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'

export const profileRoutes: Routes = [
  {
    path: 'profile',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: ProfileComponent }],
  },
]
